import DetailRadarPage, { getServerSideProps } from './index';

export default DetailRadarPage;

export { getServerSideProps };
